<div class="row">
  <div class="col-md-12 col-sm-12">
    <div class="card">
      <div class="card-header text-center">
        <p class="h3">Cobranzas</p>
      </div>
      <div class="card-body">
        <form>
        <div class="row">
          <div class="col-md-6">
            <input
            class="form-control"
            #searchTerm
            (keyup)="search(searchTerm.value)"
            placeholder="Buscar ventas..."
          />
          </div>
          <div class="col-md-6">



          </div>

        </div>
      </form>
       
        <div *ngIf="ventas && !ventaService.isLoading">
          <table class="table table-bordered table-hover table-sm table-md">
            <thead>
              <tr>
                <th>#</th>
                <th>Cod.</th>
                <th>Estado</th>
                <th>F. Registro</th>
                <th>F. Entrega</th>
                <th>Cliente</th>
                <th>Vendedor</th>
                <th>T. Venta</th>
                <th>Pagado</th>
                <th>Saldo</th>
                <th>U. Pago</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody *ngFor="let order of ventas.data; let i = index">
              <tr>
                <th scope="row">{{ i + 1 + (ventas.current_page - 1) * ventas.per_page    }}</th>
                <td>{{ order.orden_id }}</td>
                <td>
                  <span class="badge badge-info">{{ order.estado }}</span>
                </td>
                <td>{{ order.fecha }}</td>
                <td>{{ order.fecha_entrega }}</td>
                <td>
                  {{ order.cliente.nombres }} {{ order.cliente.apellidos }}
                </td>
                <td>
                  {{ order.vendedor.nombres }} 
                </td>
                
                <td>
                  {{ order.total }}
                </td>
                <td>
                  {{order.pagos | sum:'monto'}}
                </td>
                <td>
                   {{ calcularSaldo(order.total, order.pagos | sum:'monto' | number: '1.2-2' ) }}
                </td>
                <td  *ngIf="order.pagos.length == 0">
                  0

                  </td>
                <td   *ngIf="order.pagos.length > 0">
                     <p [style.background-color]="calculateDays(order.pagos[0].proximo_pago)?'red':'white'"  >
                      {{  order.pagos[0].proximo_pago| date: 'dd/MM/yyyy'}}
                    </p>
               </td>
                <td>
                  <h6 class="text-center">
                    <a
                      *hasPermission="['administrador', 'almacen']"
                      class="btn btn-info text-white"
                      [routerLink]="[
                        '/dashboard/order-details',
                        order.venta_id
                      ]"
                    >
                      Pagos
                    </a>
                  </h6>
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            Mostrando ventas {{ ventas.from }} a {{ ventas.to }} de
            {{ ventas.total }}
          </p>
          <p>Página {{ ventas.current_page }} de {{ ventas.last_page }}</p>

          <input type="number" style="width: 50px;"
          [(ngModel)]="paginanum" name="home" required min="0" step="1">
          <button (click)="searchPage(paginanum)" >
           ir
         </button>
       <br>
          <button (click)="prevPage()" [disabled]="!ventas.prev_page_url">
            Anterior
          </button>
          <button (click)="nextPage()" [disabled]="!ventas.next_page_url">
            Siguiente
          </button>
        </div>
        <p *ngIf="ventaService.isLoading">Cargando...</p>
      </div>
    </div>
  </div>
</div>
